// export const HOST = env.environment.base_url;
//localStorage.getItem('userRole');localStorage.getItem('userId')
export const Urls = {
  ProfileNo: '0000000000',
  EmpNo: '',
  RoleType: sessionStorage.getItem('userRole'),
  userFirstName: '',
  userLastName: '',
  MobileNumber: '',
  userEmailId: '',
  ApkToken: '',
  IsAPK: 'false',
  IsAPKOrWeb: '', //'?open-in-custom-tab=true' : '?open-in-browser=true';
  newBuisnessChart: '',
  myPerformanceapiURL: '',
  AdhocRequestUrl:'',
  RGTDowntimeURL:'',
  myPerformanceDetailsapiURL: '',
  monthlyBpiDashboardapiURL: '',
  monthlyBpiDetailsapiURL: '',
  teamPerformanceActiveapiURL: '',
  teamPerformanceInActiveapiURL: '',
  gpaDashboardapiURL: '',
  performanceScoreCardapiURL: '',
  performanceLettersapiURL: '',
  mtdLogin: '',
  mtdIssued: '',
  pendingProposal: '',
  newBuisnessICList: '',
  newBuisnessICDetails: '',
  icClubSummaryChart: '',
  qualityMetrixCount: '',
  earlyDeathClaim: '',
  qualityMetricsCompalaints: '',
  oppertunityMetrix: '',
  icOppertunityMetrics: '',
  qualityMetricsLetters: '',
  icOMcustomerDetails: '',
  icpospappointment: '',
  icpospURN: '',
  icpospSummary: '',
  mbgSummary: '',
  examStatusList: '',
  examDetails: '',
  resourcesapiURL: '',
  icSalesContestDropdownUrl: '',
  icSalesContest: '',
  smSalesContest: '',
  smSalesContestDropdownUrl: '',
  mtdRanking: '',
  ytdRanking: '',
  renewalReminder: '',
  notificationBirthday: '',
  notificationNotices: '',
  deleteNotice: '',
  notices: '',
  scoreCardGen: '',
  myProfileGetService: '',
  myProfileDocs: '',
  myProfileUploadSMDocs: '',
  monthlyDetailsapiURLADP: '',
  quarterDetailsapiURLADP: '',
  annualDetailsapiURLADP: '',
  isPopClose: false,
  boingStore: '',
  isBoingScriptLoded: true,
  ICprofile: {},
  imeieNo: '',
  nxtChild: '',
  preChild: '',
  serchByName: '',
  profileImg: '',
  forDashboardBottomTabs: '',
};
